var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.228,
    height: 132.962,
    viewBox: "0 0 106.228 132.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.071 7.071)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 118.82,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e0d2d2",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x2: 61.796,
    transform: "translate(15.437 14.852)",
    fill: "none",
    stroke: "#e0d2d2",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.159,
    x2: 91.942,
    transform: "translate(0.144 0)",
    fill: "none",
    stroke: "#e0d2d2",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x2: 89.115,
    transform: "translate(92.085 0) rotate(135)",
    fill: "none",
    stroke: "#e0d2d2",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x2: 57.608,
    y2: 56.439,
    transform: "translate(0 62.38)",
    fill: "none",
    stroke: "#e0d2d2",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.774-2.656,50.377,49.369",
    transform: "translate(29.826 66.481)",
    fill: "none",
    stroke: "#e0d2d2",
    strokeLinecap: "round",
    strokeWidth: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlogo);
export default __webpack_public_path__ + "static/media/rlogo.a58eb4506b076dbd0ae77864e72d4139.svg";
export { ForwardRef as ReactComponent };